import { render, staticRenderFns } from "./BaseSearch.vue?vue&type=template&id=20cfb01d&scoped=true&"
import script from "./BaseSearch.vue?vue&type=script&lang=js&"
export * from "./BaseSearch.vue?vue&type=script&lang=js&"
import style0 from "./BaseSearch.vue?vue&type=style&index=0&id=20cfb01d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cfb01d",
  null
  
)

export default component.exports